import React from 'react';
import { FaUserFriends } from 'react-icons/fa';
import styles from '../FeedbackPage.module.css'; // Adjust path if needed

const QuestionSection5 = ({
  activeSection,
  q5Referral,
  handleReferralChange,
  moveToPreviousSection,
  moveToNextSection,
  isLoading
}) => {
  return (
    <div 
    id="section-5" 
    className={`${styles.questionSection} ${activeSection === 5 ? styles.active : ''}`}
>
    <div className={styles.questionIcon}>
        <FaUserFriends />
    </div>
    <label className={styles.questionLabel}>
        5. Would you refer your friend/colleague to use EcomBuddha? <span className={styles.required}>*</span>
    </label>
    <div>
        <div className={styles.modeSelector}>
            <label className={`${styles.modeLabel} ${q5Referral === 'yes' ? styles.selected : ''}`}>
                <input
                    type="radio"
                    name="referral"
                    value="yes"
                    checked={q5Referral === 'yes'}
                    onChange={handleReferralChange}
                    disabled={isLoading}
                    required
                />
                <span>Yes</span>
            </label>
            <label className={`${styles.modeLabel} ${q5Referral === 'no' ? styles.selected : ''}`}>
                <input
                    type="radio"
                    name="referral"
                    value="no"
                    checked={q5Referral === 'no'}
                    onChange={handleReferralChange}
                    disabled={isLoading}
                    required
                />
                <span>No</span>
            </label>
        </div>
    </div>
    <div className={styles.navigationButtons}>
        <button 
            type="button" 
            className={`${styles.btn} ${styles.btnSecondary}`}
            onClick={moveToPreviousSection}
        >
            Previous
        </button>
        <button 
            type="button" 
            className={`${styles.btn} ${styles.btnPrimary}`} 
            disabled={!q5Referral}
            onClick={moveToNextSection}
        >
            Next
        </button>
    </div>
</div>
  );
};

export default QuestionSection5;
